import HeaderAffida from "../../components/header/HeaderAffida";
import ConfirmAnimation from "../../components/lotties/confirm";
import style from "./ThankYou.module.css";
import React from "react";
import {useLocation} from "react-router-dom";

interface ThankYouParam {
  message?: string;
  title?: string;
}

const ThankYou: React.FC<ThankYouParam> = () => {
    const location = useLocation();
    let title = null;
    let message = null;
    if (location) {
        title = location.state?.title;
        message = location.state?.message;
    }
  return (
    <div className="container">
      <HeaderAffida />
      <div className={style.thankYouContainer}>
        <div className={style.box}>
          <ConfirmAnimation />
        </div>
        <div className={style.box}>
          <h2>{title ? title : "Grazie per aver confermato i tuoi dati"}</h2>
          <p>{message ? message : "Un consulente Affida ti contatterà al più presto"}</p>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
